import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const ViewDocument = () => {
    const [url, setUrl] = useState(null);
    const location = useLocation();

    useEffect(() => {
        setUrl(location.state.url);
    }, []);

    return (
        <div>
            <iframe style={{ height: '100vh', width: '100vw' }} src={url} title="Files">
            </iframe>
        </div>
    );
}

export default ViewDocument;
